import { createContext, useState } from 'react';
import api from 'services/api';

const filter = {
  like: '',
  id: '',
  sigla: '',
  descricao: '',
  ativo: null,
};

export const UnidadeMedidaContext = createContext();

export const UnidadeMedidaProvider = ({ children }) => {
  const [getLoading, setGetLoading] = useState(false);
  const [unidadeMedida, setUnidadeMedida] = useState({
    data: [],
    colunas: [],
    filter,
    page: 0,
    size: 10,
  });

  const getUnidadeMedida = async (payload) => {
    try {
      setGetLoading(true);
      const { data } = await api.post('/Grid', {
        filter: unidadeMedida?.filter,
        page: unidadeMedida?.page,
        size: unidadeMedida?.size,
        order: unidadeMedida?.order,
        ...payload,
      });
      setUnidadeMedida((prev) => ({ ...prev, ...payload, ...data }));
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  return (
    <UnidadeMedidaContext.Provider
      value={{
        getLoading,
        unidadeMedida,
        getUnidadeMedida,
      }}
    >
      {children}
    </UnidadeMedidaContext.Provider>
  );
};
